// App -----------------------------------
export const LOGOUT = 'LOGOUT';
export const BIND_CARD = 'BIND_CARD';
export const GET_PAYMENT_STATUS = 'GET_PAYMENT_STATUS';
export const UPDATE_STORE_DATA_FIELD = 'UPDATE_STORE_DATA_FIELD';
